import { createRouter, createWebHistory } from 'vue-router'
import AIGCDetectionView from '../views/AIGCDetectionView.vue'
import DetectionView from '../views/DetectionView.vue'
import ManualView from '../views/ManualView.vue'
// 添加历史记录页面导入
import HistoryView from '../views/HistoryView.vue'

const routes = [
  // { path: '/detection', component: AIGCDetectionView, name: 'AIGCDetection' },
  { path: '/optimize', component: DetectionView, name: 'Optimization' },
  { path: '/manual', component: ManualView, name: 'Manual' },
  // 添加历史记录路由
  { path: '/history', component: HistoryView, name: 'History' },
  { path: '/', redirect: '/optimize' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router